export type MonitoringEventType = 'creative' | 'video';
export type DisplayEvent = 'display';
export type CreativeEvent =
  | 'ragequit'
  | 'optout'
  | 'debug_firstquartile'
  | 'loaded'
  | 'video_error_vastdownload'
  | 'close_button_click'
  | 'client_click'
  | 'viewable'
  | 'client_ignored_click'
  | 'video_error_autoplay'
  | 'video_error_prefetch'
  | 'collapse'
  | 'expand_first'
  | 'expand'
  | 'load_init'
  | 'load_error'
  | 'video_error_aborted'
  | 'video_error_network'
  | 'video_error_decode'
  | 'video_error_unsupported'
  | 'video_error'
  | 'dragged'
  | 'header_minimized'
  | 'header_minimized_default'
  | 'header_ad_below_header'
  | 'header_ad_above_header'
  | 'header_optimized'
  | 'vpaid_selected'
  | 'save_icon_click'
  | 'close_browser';

export class MediaErrorCodeConstants {
  static MEDIA_ERR_ABORTED = 1;
  static MEDIA_ERR_NETWORK = 2;
  static MEDIA_ERR_DECODE = 3;
  static MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
}
